import {
  Box,
  Flex,
  Text,
  HStack,
  Spacer,
  useTheme,
  useDisclosure,
  Spinner,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllCourses } from "../../../store/slice/courseSlice";
import SearchBox from "../../../components/searchbox/SearchBox";
import CourseTextButton from "../../../components/buttons/CoursesTextButton";
import NumberInputLimit from "../../../components/numberInput/NumberInputLimit";
import CustomTable from "../../../components/table/customTable/CustomTable";
import AddCourseModal from "../../../components/modals/AddModals/AddCourseModal";

const MyCourses = () => {
  const theme = useTheme();
  const { primaryBlue } = theme.colors.pallete;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [searchTerm, setSearchTerm] = useState("");
  const [limit, setLimit] = useState(5);

  const dispatch = useDispatch();
  const { courses, status } = useSelector((state) => state.courses);

  const [editData, setEditData] = useState(null);

  useEffect(() => {
    dispatch(getAllCourses());
  }, [dispatch]);

  const handleAddCourse = () => {
    setEditData(null);
    onOpen();
  };

  const handleEditCourse = (id) => {
    const selectedCourse = courses.find((course) => course.id === id);
    if (selectedCourse) {
      setEditData(selectedCourse);
      onOpen();
    }
  };

  const filteredCourses = courses?.filter((course) =>
    course?.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <Box>
      <Flex>
        <Text fontWeight={500} fontSize={"18px"} color={primaryBlue}>
          My Courses
        </Text>
        <Spacer />
        <CourseTextButton text={"Add Course"} onClick={handleAddCourse} />
      </Flex>
      <Flex mt={"2%"}>
        <HStack spacing={4}>
          <Text fontSize={"14px"}>Show :</Text>
          <NumberInputLimit value={limit} onChange={setLimit} />
        </HStack>
        <Spacer />
        <SearchBox onSearch={setSearchTerm} />
      </Flex>

      <Box>
        {status === "loading" ? (
          <Box
            height="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Spinner size="md" color="blue.500" />
          </Box>
        ) : (
          <CustomTable
            data={filteredCourses}
            entityType="course"
            onEdit={handleEditCourse}
            limit={limit}
          />
        )}
      </Box>

      <AddCourseModal isOpen={isOpen} onClose={onClose} editData={editData} />
    </Box>
  );
};

export default MyCourses;
